module.exports = __webpack_public_path__ + "static/media/jungle-360-screencap.8ef00e0c.jpeg";